<script lang="ts">
  import { onMount } from 'svelte';
  import SvgIcon from '../svg-icon.svelte';
  import { ConfigStore } from '../../store/config';

  let isOpen = false;
  let wrapper: HTMLElement;

  const toggle = (): void => {
    isOpen = !isOpen;
  };

  const close = (): void => {
    isOpen = false;
  };

  const handleOutsideClick = (e: MouseEvent): void => {
    if (isOpen && wrapper && !wrapper.contains(e.target as Node)) {
      isOpen = false;
    }
  };

  const handleKeydown = (e: KeyboardEvent): void => {
    if (e.key === 'Escape' && isOpen) isOpen = false;
  };

  onMount(() => {
    document.addEventListener('click', handleOutsideClick, true);
    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('click', handleOutsideClick, true);
      document.removeEventListener('keydown', handleKeydown);
    };
  });
</script>

<div class="cs-mode-switch cs-multi-option" bind:this={wrapper}>
  <button
    type="button"
    class="cs-mode-switch__trigger"
    aria-haspopup="listbox"
    aria-expanded={isOpen}
    on:click={toggle}
  >
    <span class="cs-mode-switch__label"> <SvgIcon name="plus" /></span>
  </button>
  {#if isOpen}
    <ul
      class="cs-mode-switch__menu"
      class:cs-has-mode-switch={$ConfigStore.modeSwitchOptions?.length > 0}
      role="listbox"
    >
      <slot name="dropdownElement" {close} />
    </ul>
  {/if}
</div>

<style lang="scss">
  @use './../../../scss/components/themes/multi-option-input-theme';
</style>
